import React from "react";
import gnb01 from "../../images/gnb_01.png";
import gnb02 from "../../images/gnb_02.png";
import gnb03 from "../../images/gnb_03.png";
import gnb04 from "../../images/gnb_04.png";
import gnb05 from "../../images/gnb_05.png";
import { Link, useParams } from "react-router-dom";

export default function DashboardMenu(props) {
    const { id } = useParams();

    return (
        <nav class="wrap_dashboardMenu">
            <div class="menu_gnb">
                <Link to={`/fire-on/fire-event-log/${id}/`} state={props} class="item_gnb item_gnb_01">
                    <img class="img_gnb" src={gnb01} alt="" />
                    <p class="title_gnb">동작로그</p>
                </Link>
                <Link to={`/fire-on/boundary-map/${id}/`} state={props} class="item_gnb item_gnb_02">
                    <img class="img_gnb" src={gnb02} alt="" />
                    <p class="title_gnb">경계구역일람도</p>
                </Link>
                <Link to={`/fire-on/fire-alarm-monitor/${id}/`} state={props} class="item_gnb item_gnb_03" >
                    <img class="img_gnb" src={gnb03} alt="" />
                    <p class="title_gnb">홈</p>
                </Link>
                <Link to={`/fire-on/building-info/${id}/`} state={props} class="item_gnb item_gnb_04">
                    <img class="img_gnb" src={gnb04} alt="" />
                    <p class="title_gnb">건축물정보</p>
                </Link>
                <Link to={`/fire-on/fire-equipment-status/${id}/`} state={props} class="item_gnb item_gnb_05">
                    <img class="img_gnb" src={gnb05} alt="" />
                    <p class="title_gnb">소방설비현황</p>
                </Link>
            </div>
        </nav>
    )
}